module.exports = __webpack_public_path__ + "static/img/10.972f544.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/about/images/10.jpg
// module id = ivIF
// module chunks = 21